export const DATETIME_DISPLAY_FORMAT = 'MM/DD/YYYY hh:mm A';
export const DATETIME_EXTERNAL_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]';
